import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { SecurityService } from './security.service';

@Injectable({
  providedIn: 'root'
})
export class SessionService {

  constructor(
    private cookieService: CookieService,
    private securityService: SecurityService
  ) {
  }

  get storage() {
    return sessionStorage;
  }

  private setValue(value: any): string {
    return JSON.stringify({ type: (typeof value), data: value });
  }

  private getValue(value: any): any {
    if (!!value) {
      value = JSON.parse(this.securityService.decrypt(value));
      return (value.data !== undefined) ? value.data : null;
    } else {
      return value;
    }
  }

  check(name: string): boolean {
    return this.storage.getItem(name) === null ? false : true;
    // return this.cookieService.check(name);
  }

  async get(name: string): Promise<any> {
    return await new Promise((resolve, reject) => {
      if (this.check(name)) {
        const value = this.storage.getItem(name);
        // const value = this.cookieService.get(name);
        resolve(this.getValue(value));
      } else {
        resolve(false);
      }
    });
  }

  async set(
    name: string, value: string, expires?: number | Date,
    path?: string, domain?: string, secure?: boolean
  ): Promise<any> {
    return await new Promise((resolve, reject) => {
      value = this.securityService.encrypt(this.setValue(value));
      path = (path === undefined) ? '/' : path;
      this.storage.setItem(name, value);
      // this.cookieService.set(name, value, expires, path, domain, secure);
      resolve(this.check(name));
    });
  }

  async delete(name: string, path?: string, domain?: string): Promise<any> {
    return await new Promise((resolve, reject) => {
      path = (path === undefined) ? '/' : path;
      // this.cookieService.delete(name, path, domain);
      this.storage.removeItem(name);
      resolve((!this.check(name)));
    });
  }

  async deleteAll(path?: string, domain?: string): Promise<any> {
    return await new Promise((resolve, reject) => {
      path = (path === undefined) ? '/' : path;
      // this.cookieService.deleteAll(path, domain);
      this.storage.clear();
      resolve(true);
    });
  }

}
